import { Avatar, Divider, List } from 'antd';
import MetaDecorator from 'apps/home/components/MetaDecorator';
import { useAuth } from 'context/auth-context';
import useApps from 'hooks/use-app';

const Homepage = () => {
  const { user } = useAuth();
  const { appItems } = useApps();
  const name = user?.name || user?.email || 'User';

  return (
    <>
      <MetaDecorator title={'Admin CP | Home'} />
      <h1>Hi {name} 👋</h1>
      <p>Welcome to Stag Team Workspace.</p>

      <div>
        <>
          <Divider orientation="left"></Divider>
          <List
            itemLayout="horizontal"
            dataSource={appItems}
            renderItem={(item, index) => (
              <a href={`/${item.key}`} key={index}>
                <List.Item>
                  <List.Item.Meta
                    avatar={
                      <Avatar style={{ backgroundColor: item.color }}>
                        {item.key.charAt(0).toUpperCase()}
                      </Avatar>
                    }
                    title={item.label}
                    description={item.description}
                  />
                </List.Item>
              </a>
            )}
          />
        </>
      </div>
    </>
  );
};

export default Homepage;
